// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import MessagesController from "./messages_controller"
application.register("messages", MessagesController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

